import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import TeamResourceForm from "../Layouts/TeamResourceForm";
import { TeamResourceFormValues } from "src/models/TeamResource.model";
import { useAddTeamResourceMutation } from "src/services/TeamResourceService";

type Props = {
  onClose: () => void;
};

const extensions: Record<string, string[]> = {
  IMAGE: ["JPEG", "JPG", "PNG", "GIF", "SVG"],
  PDF: ["PDF"],
  EXCEL: ["XLSX", "XLS", "CSV"],
};

const getFileType = (extension: string): string => {
  extension = extension.toUpperCase();
  for (const fileType in extensions) {
    if (extensions[fileType].includes(extension)) {
      return fileType;
    }
  }
  return "IMAGE";
};

const AddTeamResourceFormWrapper = ({ onClose }: Props) => {
  const [addTeamResource] = useAddTeamResourceMutation();

  // Form Initial Values
  const initialValues: TeamResourceFormValues = {
    visibility: "",
    fileUrl: "",
    title: "",
    sharedWithUserIds:[]
  };

  // Validation Schema
  const validationSchema = object().shape({
    fileUrl: string().required("Please upload file"),
    visibility: string().required("Please select"),
    title: string().required("Please enter title "),
  });

  // Handle Submit
  const handleSubmit = (
    values: TeamResourceFormValues,
    { setSubmitting, resetForm }: FormikHelpers<TeamResourceFormValues>
  ) => {
    const extension = values.fileUrl.split(".").pop()?.toUpperCase() || "";
    const fileType = getFileType(extension);
    const formattedValues = {
      title: values?.title,
      fileType: fileType,
      fileUrl: values?.fileUrl,
      visibility: values?.visibility,
      sharedWithUserIds: values?.sharedWithUserIds,
    };
    addTeamResource(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="md" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <TeamResourceForm
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddTeamResourceFormWrapper;
